/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER } from '@gh/builder-shared-data';
import { createRoute } from '@gh/builder-shared';
import { OfficeDetailsComponent } from './components/office-details/office-details.component';
import { OfficeListComponent } from './components/office-list/office-list.component';
import { OfficeDetailsBusinessService } from './resources/office-details-business.service';
import { OfficeListBusinessService } from './resources/office-list-business.service';

const routes = [
  createRoute({
    component: OfficeListComponent,
    path: '',
    pathMatch: 'full',
    init: OfficeListBusinessService,
    auth: {
      applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER],
    },
  }),
  createRoute({
    component: OfficeDetailsComponent,
    path: 'new',
    pathMatch: 'full',
    init: OfficeDetailsBusinessService,
    auth: {
      applicationView: [APPLICATION_VIEW_MASTER],
    },
    leave: true,
  }),
  createRoute({
    component: OfficeDetailsComponent,
    path: ':officeId',
    pathMatch: 'full',
    init: OfficeDetailsBusinessService,
    auth: {
      applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER],
    },
    leave: true,
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupOfficesRoutingModule {
}
